import request from '@/utils/request'

// 发送短信验证码
export function sendcode(data) {
  return request({
    url: 'index/login/sendcode',
    method: 'post',
    data: data
  })
}

// 后台验证短信验证码
export function testcode(data) {
  return request({
    url: 'index/login/testcode',
    method: 'post',
    data: data
  })
}

// 新增/修改 收货地址
export function address_save(data) {
  return request({
    url: 'index/person/address_save',
    method: 'post',
    data: data
  })
}

// 设置默认收货地址
export function address_default(data) {
  return request({
    url: 'index/person/address_default',
    method: 'post',
    data: data
  })
}

// 删除收货地址
export function address_del(data) {
  return request({
    url: 'index/person/address_del',
    method: 'post',
    data: data
  })
}

// 获取用户收货地址列表
export function address_list(id) {
  return request({
    url: 'index/supply/address_list',
    method: 'post',
    data: {userid: id}
  })
}

// 提交订单
export function ordersave(data) {
  return request({
    url: 'index/supply/ordersave',
    method: 'post',
    data: data
  })
}

// 收藏
export function collection_add(data) {
  return request({
    url: '/index/person/collection_add',
    method: 'post',
    data: data
  })
}

// 取消收藏
export function collection_del(data) {
  return request({
    url: '/index/person/collection_del',
    method: 'post',
    data: data
  })
}

// 获取用户信息
export function get_userinfo(data) {
  return request({
    url: '/index/person/get_userinfo',
    method: 'post',
    data: data
  })
}

// 判断支付是否成功
export function pay_status(data) {
  return request({
    url: '/index/supply/pay_status',
    method: 'post',
    data: data
  })
}

// 如果是订单管理合并付款请求新的pay_no
export function merge_pay(data) {
  return request({
    url: '/index/supply/merge_pay',
    method: 'post',
    data: data
  })
}

// 删除上传的图片
export function picDelete(data) {
  return request({
    url: '/index/algorithm/picDelete',
    method: 'post',
    data: data
  })
}

// 删除上传的bin文件
export function del_bin(data) {
  return request({
    url: '/index/algorithm/del_bin',
    method: 'post',
    data: data
  })
}

// 获取用户协议/法律声明  id 1-用户协议 2-法律声明
export function words(data) {
  return request({
    url: '/index/login/words',
    method: 'post',
    data: data
  })
}

// 修改用户信息的is_see  userid
export function edit_see(data) {
  return request({
    url: '/index/login/edit_see',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/public.js